// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"ec9b2fee","619":"826804b6","787":"5b48bd22"}[chunkId] + ".chunk.js";
};